export function aggregateUsersReportCharts(rows, formatLevelLabel) {
  const roles = new Map();
  const active = { yes: 0, no: 0 };
  const levels = new Map();

  for (const r of rows) {
    const raw = (r.roles || '').trim();
    if (raw) {
      raw.split(',').forEach((part) => {
        const role = part.trim();
        if (role) roles.set(role, (roles.get(role) || 0) + 1);
      });
    } else {
      roles.set('—', (roles.get('—') || 0) + 1);
    }
    const isA = r.is_active === 1 || r.is_active === true;
    active[isA ? 'yes' : 'no'] += 1;
    const lv = formatLevelLabel(r);
    levels.set(lv, (levels.get(lv) || 0) + 1);
  }

  const byRole = [...roles.entries()]
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 10);

  const byActive = [
    { key: 'yes', count: active.yes },
    { key: 'no', count: active.no }
  ];

  const byLevel = [...levels.entries()]
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 14);

  return { byRole, byActive, byLevel };
}

function csvEscapeCell(value) {
  const s = value == null ? '' : String(value);
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function buildUsersChartCsvAppend(rows, formatLevelLabel, t) {
  if (!rows || rows.length === 0) return '';
  const { byRole, byActive, byLevel } = aggregateUsersReportCharts(rows, formatLevelLabel);
  const lines = ['', csvEscapeCell(t('reports.usersCharts.csvBlockTitle')), ''];

  lines.push(csvEscapeCell(t('reports.usersCharts.chartRolesTitle')));
  lines.push([t('reports.users.colRole'), t('reports.dailyExercisesApi.chartStudentCount')].map(csvEscapeCell).join(','));
  for (const row of byRole) {
    lines.push([row.name, row.count].map(csvEscapeCell).join(','));
  }

  lines.push('');
  lines.push(csvEscapeCell(t('reports.usersCharts.chartActiveTitle')));
  lines.push(
    [t('reports.users.colActive'), t('reports.dailyExercisesApi.chartStudentCount')].map(csvEscapeCell).join(',')
  );
  for (const row of byActive) {
    const label = row.key === 'yes' ? t('reports.users.activeYes') : t('reports.users.activeNo');
    lines.push([label, row.count].map(csvEscapeCell).join(','));
  }

  lines.push('');
  lines.push(csvEscapeCell(t('reports.usersCharts.chartLevelsTitle')));
  lines.push(
    [t('reports.users.colSorobanLevel'), t('reports.dailyExercisesApi.chartStudentCount')].map(csvEscapeCell).join(',')
  );
  for (const row of byLevel) {
    lines.push([row.name, row.count].map(csvEscapeCell).join(','));
  }

  return `\r\n${lines.join('\r\n')}`;
}
